import { MewaStepsIcon } from '@mewa/types';

import { ReactComponent as MewaAdvantagesSecureSupplyIcon } from '../mewa-advantages/mewa_icon_secure_supply.svg';
import { ReactComponent as Droplet } from '../mewa-circle/droplet.svg';
import { ReactComponent as HeadProtection } from '../mewa-circle/head-protection.svg';
import { ReactComponent as PreparationDin14644 } from '../mewa-circle/preparation-din-14644.svg';
import { ReactComponent as Truck } from '../mewa-circle/truck-right.svg';
import { ReactComponent as CalendarMts } from './01mts.svg';
import { ReactComponent as CleanAndMaintain } from './02mbs_mts.svg';
import { ReactComponent as TruckMbs } from './03mbs.svg';
import { ReactComponent as TruckMts } from './03mts.svg';
import { ReactComponent as CalendarMbs } from './dirty_cloths_calendar.svg';
import { ReactComponent as MrsCircularClothing } from './mrs-circular-clothing.svg';

export const mewaStepsIconMap: Record<
  MewaStepsIcon,
  React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >
> = {
  [MewaStepsIcon.CalendarMbs]: CalendarMbs,
  [MewaStepsIcon.CalendarMts]: CalendarMts,
  [MewaStepsIcon.TruckMbs]: TruckMbs,
  [MewaStepsIcon.TruckMts]: TruckMts,
  [MewaStepsIcon.CleanAndMaintain]: CleanAndMaintain,
  [MewaStepsIcon.Truck]: Truck,
  [MewaStepsIcon.Droplet]: Droplet,
  [MewaStepsIcon.MbsSecureSupplyInYourArea]: MewaAdvantagesSecureSupplyIcon,
  [MewaStepsIcon.PreparationDin14644]: PreparationDin14644,
  [MewaStepsIcon.HeadProtection]: HeadProtection,
  [MewaStepsIcon.MrsCircularClothing]: MrsCircularClothing,
};

export {
  CalendarMts,
  CleanAndMaintain,
  TruckMbs,
  TruckMts,
  CalendarMbs,
  Truck,
  Droplet,
  PreparationDin14644,
  HeadProtection,
  MrsCircularClothing,
  MewaAdvantagesSecureSupplyIcon,
};
